import { Input } from "antd";
import { SearchIcon } from "assets/icons";
import "./style.scss";

export default function Search({ onSearch, className = "" }) {
  return (
    <Input
      placeholder="Search"
      prefix={<SearchIcon />}
      className={`custom-search ${className}`}
      onChange={(e) => onSearch?.(e.target.value)}
    />
  );
}
